export default "__VITE_ASSET__De0aFqoV__"